import React from "react";
import styled from "styled-components";

const GridWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-height: ${props => props.maxListHeight}px;
  overflow-y: scroll;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 290px;
  margin-top: 10px;
`;

export const TabSelectMenuGridPane = ({
  activeRowIndex,
  defaultActiveRowIndex,
  menuItems,
  searchValue,
  maxListHeight
}) => {
  return (
    <GridWrapper maxListHeight={maxListHeight}>
      <Grid>
        {menuItems.map(({ onSelect, render, key }, index) =>
          render({
            active: index === activeRowIndex,
            onClick: onSelect,
            key
          })
        )}
      </Grid>
    </GridWrapper>
  );
};
